
import { useParams } from "react-router-dom";
import { useClasseContext } from "../context/ClasseContext";

import {useEvalNat} from "../hooks/fetch_api_hook/useEvalNat";
import { useMemo, useState } from "react";
import { useGroupe } from "../hooks/fetch_api_hook/useGroupe";
import ResultatEvalNat from "../components/VueEvalNat/EvalNat/ResultatEvalNat";
import { useCallback } from "react";
import EvalNational from "./EvalNational";
import EvalBilan from "./EvalBilan";
import SelectEvalBilan from "../components/VueGroupe/SelectEvalBilan";
import Loading from "../components/general/Loading";
import PilotageTabs from "../components/general/PilotageTabs";
import { getClassesWithoutNationalEvaluations } from "../utils/evalnatfunction";
import { niveauDe, restreindreAuxClasses } from "../utils/campagneEvalNat";
import { useUser } from "../context/UserContext";
import { useEffect } from "react";
const EvalNatLoader = ({typeComponent, selectedClasse,setClasseWithoutResults, setSchoolWithouthResults,  bySchool = false, selectedMatiere, niveauEvalnat, evalsNatGroupeFromParent}) => {
    const { idclasse } = useParams();
    const { classeNom, groupNom } = useClasseContext();
    const { etablissementData, matiereFilter} = useUser();
    const [reload,setReload] = useState(false)

 // On recupère les évaluations nationale de la classe, si on sélectionner une classe en particulier.
 // Si chef d'établissement, matiereFilter sera défini et on filtre par matière
   const {data: EvalsNatClasse, isLoading: isLoadingEvalNatClasse, isError} = useEvalNat(
    null,
    parseInt(idclasse,10),
    reload,
    classeNom==="" && "not-enabled",
    matiereFilter // Chef: filtré par matière, Prof: undefined donc pas de filtre
  );

   // On recupère toutes les évaluations nationales de tout l'établissement (chef uniquement).
   // Skip si evalsNatGroupeFromParent fourni (DashboardChef) ou si mode groupe (on utilise evalsNatByGroupe)
   const shouldFetchEvalsNatGroupe = !evalsNatGroupeFromParent && etablissementData?.id && classeNom === "" && !groupNom;
   const { data: evalsNatGroupeFetched, isLoading: isLoadingEvalNat } = useEvalNat(
    etablissementData?.id ? `?etablissement_id=${parseInt(etablissementData.id, 10)}` : null,
    null,
    null,
    !shouldFetchEvalsNatGroupe && "not-enabled"
  );

   // Fetch par établissement + groupe_id en mode groupe (nationale + bilan)
   // Le backend filtre par niveau du groupe + bilans du groupe (évite de renvoyer tout l'établissement)
   const shouldFetchByGroupe = groupNom && classeNom === "";
   const { data: evalsNatByGroupe, isLoading: isLoadingByGroupe } = useEvalNat(
    etablissementData?.id ? `?etablissement_id=${parseInt(etablissementData.id, 10)}&groupe_id=${idclasse}` : null,
    null,
    reload,
    !shouldFetchByGroupe && "not-enabled"
  );

  // Fusionner les "Evaluation Nationale" / "Devoir Commun" multi-classes en une seule entrée
  // et garder les bilans tels quels (mode groupe uniquement)
  const evalsNatByGroupeMerged = useMemo(() => {
    if (!evalsNatByGroupe || evalsNatByGroupe.length === 0) return evalsNatByGroupe;

    const nationalesMerged = Object.values(groupedByTitle(evalsNatByGroupe));
    const bilans = evalsNatByGroupe.filter(e =>
      !e.titre.includes("Devoir Commun") && !e.titre.includes("Evaluation Nationale")
    );

    return [...nationalesMerged, ...bilans];
  }, [evalsNatByGroupe]);

  // Groupe → fetch léger par groupe_id, Chef → données parent ou fetch établissement
  const EvalsNatGroupe = groupNom
    ? evalsNatByGroupe
    : (evalsNatGroupeFromParent || evalsNatGroupeFetched);
    // Dans le cas où on est dans un espace de  Groupe, idclasse correspondra à l'id du groupe, il faudra donc recuperer les élèves de ce groupe pour recuperer leurs evals
    // nationales qui matchent.
    const { data: groupeData, isLoading: isGroupeLoading, isError: isGroupeError } = useGroupe(idclasse+"/",  groupNom==="" &&  "not-enabled",null);  
    
    // Regrouper les évaluations par titre qui contiennent "Devoir Commun" ou "Évaluation Nationale"
    function groupedByTitle(filteredEvals) {    
            return filteredEvals.reduce((acc, evaluation) => {
                const title = evaluation.titre;
                // Vérifier si le titre contient l'une des chaînes spécifiées
                if (title.includes("Devoir Commun") || title.includes("Evaluation Nationale")) {
                if (!acc[title]) {
                    acc[title] = { ...evaluation, eleves_reponses: [] };
                }
                // Fusionner les réponses des élèves pour les évaluations avec le même titre
                acc[title].eleves_reponses.push(...evaluation.eleves_reponses);
                }
                return acc;
            },{}
        )

        }  
 
  const filterEvalNatResponses = useCallback((evalObject, groupe) => {
          
            // Extrait les ID des élèves du groupe
            let filteredEvals = evalObject.filter((evaluation) => groupe.classes_detail.includes(evaluation.classe_nom));
            filteredEvals = Object.values(groupedByTitle(filteredEvals));
            let updatedEvalNat;
            // Filtre les réponses pour ne garder que celles des élèves du groupe
            if(groupNom){
                const groupeEleveIds = groupe.eleves.map(eleve => '' + eleve.id);
             
             updatedEvalNat = filteredEvals.map(evaluation => {
                const filteredElevesReponses = evaluation.eleves_reponses.filter(reponse => groupeEleveIds.includes(reponse.id_eleve));
                return {
                    ...evaluation,
                    eleves_reponses: filteredElevesReponses
                };
            });
        }
        else{
             updatedEvalNat = filteredEvals
        }
        
            return updatedEvalNat;
        }, [groupNom]);


 
        
  function getSchoolsWithoutNationalEvaluations(EvalsNatGroupe) {
          // Créer un tableau pour stocker les écoles qui n'ont pas de résultats
          const ecolesSansResultats = [];
          // Créer un Set pour stocker les écoles qui ont des résultats
          const ecolesAvecResultats = new Set();
        
          // Parcourir les évaluations nationales pour identifier les écoles ayant des résultats
          if (EvalsNatGroupe && EvalsNatGroupe.length > 0) {
            EvalsNatGroupe.forEach((evaluation) => {
              if (evaluation.eleves_reponses && evaluation.eleves_reponses.length > 0) {
                evaluation.eleves_reponses.forEach((reponse) => {
                  if (reponse.ecole_secteur) {
                    ecolesAvecResultats.add(reponse.ecole_secteur);
                  }
                });
              }
            });
          }
        
          // Identifier les écoles sans résultats en comparant avec le Set
          const nomsEcoles = selectedClasse.map((classe) => classe.label);
        
          nomsEcoles.forEach((ecoleName) => {
            if (!ecolesAvecResultats.has(ecoleName)) {
              ecolesSansResultats.push(ecoleName);
            }
          });
          // Retourner la liste des écoles sans résultats
          return ecolesSansResultats;
        }

// Utiliser useMemo pour calculer les évaluations filtrées
const evalfiltered = useMemo(() => {
  if (bySchool) {
    if (EvalsNatGroupe && EvalsNatGroupe.length > 0) {
      const selectedSchools = selectedClasse ? selectedClasse.map((classe) => classe.label) : null;

      const transformedEvaluations = EvalsNatGroupe
        .filter((evaluation) => !selectedMatiere || evaluation.matiere === selectedMatiere) // Filtre par matière
        // Écoles de secteur : la 6e seulement (une campagne par niveau arrive entière, D9)
        .filter((evaluation) => niveauDe(evaluation) === "6")
        .map((evaluation) => ({
          ...evaluation,
          eleves_reponses: evaluation.eleves_reponses
            .filter((reponse) => {
              if (selectedSchools) {
                return selectedSchools.includes(reponse.ecole_secteur);
              }
              return true;
            })
            .map((reponse) => ({
              ...reponse,
              classe_nom: reponse.ecole_secteur || "Non défini",
            })),
        }));

      const filteredEvaluations = transformedEvaluations.filter((evaluation) => evaluation.eleves_reponses.length > 0);

      return Object.values(groupedByTitle(filteredEvaluations));
    }
    return [];
  } else if (!classeNom && !groupNom) {
    if (EvalsNatGroupe && EvalsNatGroupe.length > 0 && selectedClasse && selectedClasse.length > 0) {
      const selectedClassesNames = selectedClasse.map((classe) => classe.label);

      // Filtre par matière avant de réduire aux classes cochées
      const evalsFiltered = selectedMatiere
        ? EvalsNatGroupe.filter(e => e.matiere === selectedMatiere)
        : EvalsNatGroupe;

      // La campagne du niveau choisi arrive entière (D9) : on garde ses copies des classes cochées. Les
      // évaluations par classe d'avant la fusion sont gardées par leur nom de classe.
      return Object.values(groupedByTitle(restreindreAuxClasses(evalsFiltered, selectedClassesNames, niveauEvalnat)));
    }
    return [];
  } else if (!classeNom) {
    if (Object.values(groupeData).length > 0 && Object.values(EvalsNatGroupe).length > 0) {
      // Filtre par matière
      const evalsFiltered = selectedMatiere
        ? EvalsNatGroupe.filter(e => e.matiere === selectedMatiere)
        : EvalsNatGroupe;

      return filterEvalNatResponses(evalsFiltered, groupeData);
    }
    return [];
  }
}, [EvalsNatGroupe, classeNom, groupNom, groupeData, filterEvalNatResponses, selectedClasse, bySchool, selectedMatiere, niveauEvalnat]);

  useEffect(() => {
    // On calcule les classes manquantes même si EvalsNatGroupe est vide ou undefined
    // Car s'il n'y a pas de résultats, toutes les classes sont "sans résultats"
    const evalsData = EvalsNatGroupe || [];

    if (bySchool && etablissementData) {
      setSchoolWithouthResults(getSchoolsWithoutNationalEvaluations(evalsData));
      setClasseWithoutResults(getClassesWithoutNationalEvaluations(etablissementData, evalsData, "6", selectedMatiere));
    } else if (!classeNom && !groupNom && niveauEvalnat && etablissementData) {
      setClasseWithoutResults(getClassesWithoutNationalEvaluations(etablissementData, evalsData, niveauEvalnat, selectedMatiere));
    }
  }, [
    bySchool,
    EvalsNatGroupe,
    etablissementData,
    classeNom,
    groupNom,
    setSchoolWithouthResults,
    setClasseWithoutResults,
    selectedMatiere,
    niveauEvalnat,
  ]);
    
      const handleReloadEvalNat = () => {
        setReload(prevReload => !prevReload);
      }

const isAnyLoading = isLoadingEvalNatClasse || isLoadingEvalNat || isGroupeLoading || isLoadingByGroupe;
const hasData = EvalsNatClasse?.length > 0 || evalsNatByGroupe?.length > 0 || evalsNatGroupeFetched?.length > 0 || evalsNatGroupeFromParent?.length > 0;

// Loading plein écran uniquement au chargement initial (pas encore de données)
if (isAnyLoading && !hasData){
    return (
        <Loading loadingText={"Chargement..."}/>

    )
}

if(isError || isGroupeError){
    return (<div>
        Erreur..
    </div>)
}


        if(classeNom)
          {
          return (
              <>
              {typeComponent==="nationale" && <PilotageTabs />}
              {(EvalsNatClasse &&typeComponent==="nationale") &&    <div className="pilotage-enter"><EvalNational EvalsNat={EvalsNatClasse} selectedMatiere={matiereFilter} /></div>}
              {(typeComponent==="bilan") &&  <EvalBilan handleReloadEvalNat={handleReloadEvalNat} EvalsNat={EvalsNatClasse} reload={reload}/> }
              </>
                    )
                }
        else if(groupNom){
            return(<>
            {typeComponent==="nationale" && <PilotageTabs />}
            {(evalfiltered && typeComponent==="nationale") &&  <div className="pilotage-enter"><ResultatEvalNat EvalsNat={evalfiltered} selectedMatiere={selectedMatiere} classe={true} /></div>}
            {(evalsNatByGroupeMerged && typeComponent==="bilan") && <EvalBilan handleReloadEvalNat={handleReloadEvalNat} EvalsNat={evalsNatByGroupeMerged} reload={reload}/> }
            </>
            )
        }
        else{
            return(<>
            {(evalfiltered && typeComponent==="nationale") &&  <div className="pilotage-enter"><ResultatEvalNat EvalsNat={evalfiltered} selectedMatiere={selectedMatiere} classe= {true} /></div>}
            {(evalfiltered && typeComponent==="bilan") && <SelectEvalBilan EvalNat={evalfiltered.filter((evaluation) => evaluation.titre ==="Evaluation Nationale")}
            listEvals={evalfiltered.filter((evaluation) => evaluation.titre !=="Evaluation Nationale")} /> }
            </>
            )
        }
}

export default EvalNatLoader;